import { render, staticRenderFns } from "./deviceMobile.vue?vue&type=template&id=d2124eda&scoped=true&"
import script from "./deviceMobile.vue?vue&type=script&lang=js&"
export * from "./deviceMobile.vue?vue&type=script&lang=js&"
import style0 from "./deviceMobile.vue?vue&type=style&index=0&id=d2124eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2124eda",
  null
  
)

export default component.exports